import { Survey } from "models/nostradamus/moral-psychological-support/Survey";
import { CrudRestApi } from "../../api";

const apiUrl = "admin/survey";
const rest = CrudRestApi(apiUrl, Survey);

const SurveyService = {
    ...rest,
};

export default SurveyService;
